import {Component} from '@angular/core';

@Component({
    selector: 'vui-form-groups',
    templateUrl: './form-groups.component.html',
    styleUrls: ['./form-groups.component.scss']
})
export class FormGroupsComponent {
}


